import { Inject } from '@odinjs/odin';

import { ENDPOINTS } from '@philips-emr/hpms-health-insurance-commons';
import { PanelAPI, TextAPI } from '@philips-emr/tws-components';
import Controller, { OnClick, OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService, MessageService } from '@philips-emr/tws-core/lib/services';
import { format } from '@philips-emr/tws-core/lib/services/model-service';
import { isEmptyOrBlankString } from '@philips-emr/tws-utils';

import { FragmentNames } from '../codegen';
import { MyDataAliases as Aliases } from '../codegen/constants/aliases/my-data-aliases';
import { APPLICATION_ROUTES } from '../route';

import BaseController from './BaseController';

interface User {
  name: string;
  cdPhysicalPerson: string;
  dsEmail: string;
  dtLastAccess: string;
}

@Controller({ fragment: FragmentNames.MY_DATA })
export default class HomeController extends BaseController {

  @Inject(Aliases.TEXT_LAST_ACCESS)
  private lastAccessText: TextAPI;

  @OnClick(Aliases.LINK_PRIVACY)
  onClickPrivacy(): void {
    this.historyService.push(APPLICATION_ROUTES.PRIVACY);
  }

  @OnMount(Aliases.PANEL_LAST_ACCESS)
  public onMountPanelLastAccess(event: MountEvent): void {
    const api = event.target as unknown as PanelAPI;
    const setVisibility = (visibility: boolean): void => api.setVisible(visibility);
    const { nrSeqUser } = this.context.getBulkData();

    void HttpService.get<User>(ENDPOINTS.GET.MY_DATA_USER, { nrSeqUser })
      .then(({ body: user }) => {
        let visibility = false;
        if (user && !isEmptyOrBlankString(user.dtLastAccess)) {
          visibility = true;

          const message = MessageService.translate('hi.hello-user-last-access')
            .replace('#@NM_USUARIO#@', user.name)
            .replace('#@DT_ULTIMO_ACESSO#@', format('date', user.dtLastAccess, { type: 'timestamp' }));

          this.lastAccessText.setValue(message);
        } else if (user) {
          visibility = true;
          const message = `${MessageService.translate('hi.hello')} ${user.name}. ${MessageService.translate('hi.welcome-first-acess')}`;
          this.lastAccessText.setValue(message);
        }

        setVisibility(visibility);
      }).catch(() => setVisibility(false));
  }

}
